var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"refer",on:{"click":_vm.backToPatientList}},[_vm._v(_vm._s(_vm.$t('modals.header_layout.back.title')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }